import { ValidationErrors } from 'final-form';

import { makeRequired } from 'CorePackage/MainModule/validators/isRequired';
import { REQUIRED_ERROR } from 'CorePackage/MainModule/constants/validationErrors';
import { ProfKindCodesEnum } from 'APIPackage/DictionariesModule/enums/ProfKindCodesEnum';
import { ICreatePreventionForm } from 'PreventionPackage/MainModule/interfaces/ICreatePreventionForm';

export const validateCreateErpModal = (values: ICreatePreventionForm): ValidationErrors => {
  const isTypeOP = values.profKind?.code === ProfKindCodesEnum.OP;

  return {
    federalLaw: makeRequired(REQUIRED_ERROR)(values.federalLaw),
    supervisionTypePm: makeRequired(REQUIRED_ERROR)(values.supervisionTypePm),
    knoOrganizationPm: makeRequired(REQUIRED_ERROR)(values.knoOrganizationPm),
    stopDate: makeRequired(REQUIRED_ERROR, () => isTypeOP)(values.stopDate),
    startDate: makeRequired(REQUIRED_ERROR)(values.startDate),
    profKind: makeRequired(REQUIRED_ERROR)(values.profKind),
    reason: {
      type: makeRequired(REQUIRED_ERROR)(values.reason?.type),
    },
    prosecutorOrganization: makeRequired(REQUIRED_ERROR)(values.prosecutorOrganization),
  };
};
